// extracted by mini-css-extract-plugin
module.exports = {"container":"register_container__1lbFB","content":"register_content__16Cob"};